import { createFileRoute } from '@tanstack/react-router'
import Publication from '../../../../components/Publications/Publication'
import NotFound from '../../../../components/Common/NotFound'

export const Route = createFileRoute('/_layout/d/id/$classicId')({
  component: Publication,
  params: {
    parse: (params) => ({
      classicId: Number(params.classicId),
    }),
    stringify: (params) => ({
      classicId: String(params.classicId),
    }),
  },
  notFoundComponent: NotFound,
})
